module.exports = "/_next/static/images/row1-2-aea423e84d8c86551623e98cc4f27318.png";